import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const information_small: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...rest}>
      <path
        fill="none"
        stroke={iconColor}
        d="M12.48,7.9997 L12.48,5.9997 M14.9805,16.49 L9.9805,16.49 M12.48,16.49
      L12.48,10.49 L10,10.49"
      />
    </svg>
  );
};
